import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Plan: ITypeSpecificPolicy<types.Plan> = {
  fields: {
    createdDate: dateTimeFieldPolicy(),
    updatedDate: dateTimeFieldPolicy()
  }
};
